module.exports = __webpack_public_path__ + "img/mission_materials.baabec0e.svg";